import React, { Component } from "react";
import PropTypes from "prop-types";
//import styled from 'styled-components';
import Layout from "../Layout";
import { Layout2 } from "../RowBox";
//import {DivContainer} from './styled';
import { DivHover, DivHelp } from "./styled";

class Row2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
      hover1: false
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="Row" />
        {this.state.hover && <DivHelp>Row</DivHelp>}
      </DivHover>
    );
  }
}

Row2.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func
};

Row2.defaultProps = {
  childOf: "Row",
  values: {
    name: "Row2",
    parent: "Body",
    type: "Row",
    backgroundColor: "rgba(255,255,255,0)",
    backgroundImage: {
      url: "",
      urlMobile: ""
    },
    bgProps: {
      size: "cover",
      position: "center",
      repeat: "no-repeat",
      ratio: 1.2
    },
    align: "center",
    isBackgroundImage: false,
    padding: "0px",
    width: {
      type: "%",
      contentWidth: 100
    }
  },
  content: [
    {
      type: "Content",
      props: {
        values: {
          parent: "Row",
          type: "Content",
          className: "col-xs-12 col-lg-6 col-md-6",
          column: 2,
          backgroundColorParent: "rgba(255,255,255,0)",
          backgroundColor: "rgba(255,255,255,0)",
          backgroundImage: {
            url: "",
            urlMobile: "",
            desktop: {
              width: 0,
              height: 0
            },
            mobile: {
              width: 0,
              height: 0
            }
          },
          bgProps: {
            size: "cover",
            position: "center",
            repeat: "no-repeat",
            ratio: 1.2
          },
          isBackgroundImage: false,
          padding: "0px",
          width: {
            type: "%",
            contentWidth: 100
          },
          alignment: {
            vertical: "center",
            horizontal: "center"
          }
        }
      },
      children: [],
      childOf: "Row"
    },
    {
      type: "Content",
      props: {
        values: {
          parent: "Row",
          type: "Content",
          className: "col-xs-12 col-lg-6 col-md-6",
          column: 2,
          backgroundColorParent: "rgba(255,255,255,0)",
          backgroundColor: "rgba(255,255,255,0)",
          backgroundImage: {
            url: "",
            urlMobile: "",
            desktop: {
              width: 0,
              height: 0
            },
            mobile: {
              width: 0,
              height: 0
            }
          },
          bgProps: {
            size: "cover",
            position: "center",
            repeat: "no-repeat",
            ratio: 1.2
          },
          isBackgroundImage: false,
          padding: "0px",
          width: {
            type: "%",
            contentWidth: 100
          },
          alignment: {
            vertical: "center",
            horizontal: "center"
          }
        }
      },
      children: [],
      childOf: "Row"
    }
  ],
  layout: Layout2
};
export default Row2;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Row/Row2.js